import {svgIconWrapper} from '../svg-icon-wrapper';

import LeadpagesRegular from './leadpages-regular-icon.svg';

function SvgComponent(props: React.SVGProps<SVGSVGElement>) {
    return <LeadpagesRegular {...props} />;
}

SvgComponent.iconName = 'leadpagesRegular';

export const LeadpagesRegularIcon = svgIconWrapper(SvgComponent);
